exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle[data-v-1fb705be]{-webkit-animation:spin-data-v-1fb705be 1s linear infinite;animation:spin-data-v-1fb705be 1s linear infinite}@-webkit-keyframes spin-data-v-1fb705be{0%{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}to{-webkit-transform:rotateY(1turn);transform:rotateY(1turn)}}@keyframes spin-data-v-1fb705be{0%{-webkit-transform:rotateY(0deg);transform:rotateY(0deg)}to{-webkit-transform:rotateY(1turn);transform:rotateY(1turn)}}", ""]);

// exports
